import { authGuard } from '@myre/ui-domain-core';

import { type Routes } from '@angular/router';

import { ConnectedComponent } from './connected.component';
import { AdminGuard } from './guards/admin.guard';
import { ErrorComponent } from './shared/error/error.component';

export const APP_ROUTES: Routes = [
  {
    path: 'legal',
    loadChildren: () =>
      import('./static-pages/static-pages.routes').then(m => m.staticRoutes),
  },
  {
    path: 'me',
    component: ConnectedComponent,
    loadChildren: () => import('./me/me-routing.module').then(m => m.ROUTES),
    canActivate: [authGuard()],
  },
  {
    path: '',
    loadChildren: () => import('./public/public.routes').then(m => m.ROUTES),
    canActivate: [
      authGuard({
        redirect: {
          isNotAuth: 'none',
          isAuth: 'me',
        },
      }),
    ],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin-routing.module').then(m => m.ROUTES),
    canActivate: [authGuard(), AdminGuard],
  },
  {
    path: 'forbidden',
    component: ErrorComponent,
    data: { errorCode: 403 },
  },
  {
    path: '**',
    component: ErrorComponent,
    data: { errorCode: 404 },
  },
];
